import * as XLSX from "xlsx-js-style";

// Array导出excel方法
export const Array2XLSX=(arr,title,length)=>{
  // json_to_sheet: 将一个由对象组成的数组转成sheet；
  let sheet = XLSX.utils.aoa_to_sheet(arr)

    //*****以下是样式设置，样式设置放在组织完数据之后，xlsx-js-style的核心API就是SheetJS的 *//
    Object.keys(sheet).forEach(key => {
      // 非!开头的属性都是单元格
      let cell=XLSX.utils.decode_cell(key)
      if(cell.r==0){
        sheet[key].t='s'
        sheet[key].s={
          font: {
            bold: true,
            sz: 14,
            name: 'Times New Roman',
          },
          alignment: {
            vertical: 'center',
            horizontal: 'center',
            wrapText: true
          },
          border: {
            top: { style: 'thin' },
            right: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' }
          }
        }
      }
      if(cell.r==1||cell.r==2){
        sheet[key].t='s'
        sheet[key].s={
          font: {
            bold: true,
            sz: 11,
            name: 'Times New Roman',
          },
          alignment: {
            vertical: 'center',
            horizontal: 'center',
            wrapText: true
          },
          border: {
            top: { style: 'thin' },
            right: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' }
          }
        }
        if(cell.c==2||cell.c==6){
          sheet[key].s={
            font: {
              bold: false,
              sz: 11,
              name: 'Times New Roman',
            },
            alignment: {
              vertical: 'center',
              horizontal: 'center',
              wrapText: true
            },
            border: {
              top: { style: 'thin' },
              right: { style: 'thin' },
              bottom: { style: 'thin' },
              left: { style: 'thin' }
            }
          }
        }
      }
      if(cell.r==3){
        sheet[key].t='s'
        sheet[key].s={
          font: {
            bold: false,
            sz: 11,
            name: 'Times New Roman',
          },
          alignment: {
            vertical: 'center',
            horizontal: 'left',
            wrapText: true
          },
          border: {
            top: { style: 'thin' },
            right: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' }
          }
        }
      }
      if(cell.r>3){
        sheet[key].s = {
          font: {
            name:'Times New Roman',
            sz: "10",
            color: { rgb: "000000" }
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true
          },
          border: {
            top: { style: 'thin' },
            right: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' }
          }
        }
        if((cell.r==6)&&cell.c==6){
          delete sheet[key].w
          let fcell_1=XLSX.utils.encode_cell({r:12,c:6})
          let fcell_2=XLSX.utils.encode_cell({r:(length+11),c:6})
          sheet[key].z='￥0.00'
          sheet[key].t='n'
          sheet[key].f=`SUM(${fcell_1}:${fcell_2})`
          sheet[key].s.alignment = {
            horizontal: "center",
            vertical: "center",
            wrapText: true
          }
        }
        if(cell.r==7){
          sheet[key].t='s',
          sheet[key].s= {
            font: {
              bold: false,
              sz: 11,
              name: 'Times New Roman',
              color: { rgb: "000000" }
            },
            alignment: {
              vertical: 'center',
              horizontal: 'left',
              wrapText: true
            },
            border: {
              top: { style: 'thin' },
              right: { style: 'thin' },
              bottom: { style: 'thin' },
              left: { style: 'thin' }
            }
          }
        }
        if(cell.r==8||cell.r==10){
          sheet[key].t='s',
          sheet[key].s= {
            font: {
              bold: true,
              sz: 11,
              name: 'Times New Roman',
              color: { rgb: "000000" }
            },
            alignment: {
              vertical: 'center',
              horizontal: 'center',
              wrapText: true
            },
            border: {
              top: { style: 'thin' },
              right: { style: 'thin' },
              bottom: { style: 'thin' },
              left: { style: 'thin' }
            }
          }
        }
        if(cell.r==9){
          sheet[key].t='s',
          sheet[key].s= {
            font: {
              bold: false,
              sz: 11,
              name: 'Times New Roman',
              color: { rgb: "000000" }
            },
            alignment: {
              vertical: 'center',
              horizontal: 'left',
              wrapText: true
            },
            border: {
              top: { style: 'thin' },
              right: { style: 'thin' },
              bottom: { style: 'thin' },
              left: { style: 'thin' }
            }
          }
        }
        if(cell.r>11&&cell.r<length+12){
          if(cell.c==2){
              sheet[key].s.alignment= {
                horizontal: "left",
                vertical: "center",
                wrapText: true
              }
          }
          if(cell.c==5){
            const currency_unit=sheet[key].v[0]
            sheet[key].v=sheet[key].v.slice(1)
            sheet[key].t='n'
            //计算第6列
            let fcell_5=XLSX.utils.encode_cell({r:cell.r,c:cell.c})
            let fcell_4=XLSX.utils.encode_cell({r:cell.r,c:(cell.c-1)})
            let fcell_6=XLSX.utils.encode_cell({r:cell.r,c:(cell.c+1)})
            switch(currency_unit){
              case '￥':
                sheet[key].z='￥0.00';
                sheet[fcell_6].z='￥0.00';
                break;
              case '$':
                sheet[key].z='$0.00';
                sheet[fcell_6].z='$0.00';
                break;
            }
            sheet[fcell_6].t='n';
            sheet[fcell_6].f=`${fcell_5}*${fcell_4}`;
          }
        }
        if((cell.r==length+12)&&cell.c==6){
          delete sheet[key].w
          let fcell_1=XLSX.utils.encode_cell({r:12,c:6})
          let fcell_2=XLSX.utils.encode_cell({r:(length+11),c:6})
          sheet[key].z='￥0.00'
          sheet[key].t='n'
          sheet[key].f=`SUM(${fcell_1}:${fcell_2})`
          sheet[key].s.alignment = {
            horizontal: "center",
            vertical: "center",
            wrapText: true
          }
        }
    }
    })
    // 设置合并单元格
    const merges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } },//第一行

      { s: { r: 1, c: 0 }, e: { r: 1, c: 1 } },//第二行
      { s: { r: 1, c: 2 }, e: { r: 1, c: 3 } },
      { s: { r: 1, c: 4 }, e: { r: 1, c: 5 } },
      { s: { r: 1, c: 6 }, e: { r: 1, c: 8 } },

      { s: { r: 2, c: 0 }, e: { r: 2, c: 1 } },//第三行
      { s: { r: 2, c: 2 }, e: { r: 2, c: 3 } },
      { s: { r: 2, c: 4 }, e: { r: 2, c: 5 } },
      { s: { r: 2, c: 6 }, e: { r: 2, c: 8 } },

      { s: { r: 3, c: 0 }, e: { r: 3, c: 8 } },//第四行

      { s: { r: 5, c: 0 }, e: { r: 5, c: 8 } },//第六行

      { s: { r: 6, c: 0 }, e: { r: 6, c: 1 } },//第七行
      { s: { r: 6, c: 2 }, e: { r: 6, c: 5 } },
      { s: { r: 6, c: 6 }, e: { r: 6, c: 8 } },

      { s: { r: 7, c: 0 }, e: { r: 7, c: 8 } },//第八行

      { s: { r: 8, c: 0 }, e: { r: 8, c: 3 } },//第九行
      { s: { r: 8, c: 4 }, e: { r: 8, c: 8 } },

      { s: { r: 9, c: 0 }, e: { r: 9, c: 3 } },//第十行
      { s: { r: 9, c: 4 }, e: { r: 9, c: 8 } },

      { s: { r: 10, c: 0 }, e: { r: 10, c: 8 } },//第十一行

      { s: { r: length+12, c: 0 }, e: { r: length+12, c: 1 } },
    ]
    sheet['!merges'] = merges;
    // 设置每列的宽度
    let cols = [];
    // wpx 字段表示以像素为单位，wch 字段表示以字符为单位
    for (let i = 0; i <= 8; i++) {
      let col = {};
      if(i==0){
        col.wch =6;
      } else if (i == 2) {
        col.wch = 30;
      } else if (i == 3) {
        col.wch = 6;
      } else if (i == 4) {
        col.wch =9;
      } else{
        col.wch = 12;
      }
      cols.push(col)
    }
    sheet['!cols']=cols
    //设置表头的行高
    const rows=new Array(length+12)
    rows[0]={hpx:30}
    rows[1]={hpx:30}
    rows[2]={hpx:30}
    rows[3]={hpx:30}
    rows[4]={hpx:30}
    rows[5]={hpx:30}
    rows[6]={hpx:30}
    rows[7]={hpx:220}
    rows[8]={hpx:30}
    rows[9]={hpx:140}
    rows[10]={hpx:30}
    rows[11]={hpx:30}
    rows[length+12]={hpx:30}
    sheet['!rows']=rows
  //*****EXCEL样式设置结束 *//

  // 新建表格
  let book = XLSX.utils.book_new()
  // 在表格中插入一个sheet
  XLSX.utils.book_append_sheet(book, sheet, "sheet1")
  // 通过xlsx的writeFile方法将文件写入
  XLSX.writeFile(book, title)
}
